
import { useGalponesQuery } from "../../../hooks";
import { DisenioPaginas } from "../../layout";
import { BuscadorSoloValor, CargandoMedio, TablaListGalpones } from "../../components";



export const ListadoGalpones = () => {


    const { galponesListQuery, page, termino, chagePage, chageTermino } = useGalponesQuery()


    return (

        <DisenioPaginas titulo="Listado de Galpones" url="add/galpon">
            {(galponesListQuery.isLoading)
            ?   <CargandoMedio titulo="Cargando Galpones..." />
            :   <>
                <BuscadorSoloValor termino={termino} chageTermino={chageTermino} 
                    titulo='Buscar galpon...' place='Buscar x nombre...'
                />
                <TablaListGalpones data={galponesListQuery.data || []} chagePage={chagePage} page={page} />
                </>
            }

        </DisenioPaginas>

    )
}
